import { jsx as _jsx } from "react/jsx-runtime";
import { useIoContext, useOverlayContext } from '~/contexts';
import { getStoreUrl } from '../AppPromo.utils';
import { AppPromoModal } from '../AppPromoModal/AppPromoModal';
export const useAppPromoClick = ()=>{
    const { browser } = useIoContext();
    const { showModal } = useOverlayContext();
    const openPromoModal = ()=>showModal({
            biName: 'mobile_app_promo_modal',
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(AppPromoModal, {
                    dismissModal: dismissModal
                });
            }
        });
    return ()=>{
        const storeUrl = getStoreUrl(browser.getUserAgent());
        if (storeUrl != null) {
            browser.openNewTab(storeUrl);
        } else {
            void openPromoModal();
        }
    };
};
